// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleTimestamp_root__KjSeU","link":"ArticleTimestamp_link__DdXIj"};